/**
 *
 * @export
 * @class SystemConfig
 */
 export class SystemConfig {
    //Fields
    IpAddress: string;
    CpuUsage: string;
    RamUsage: string;

    DbServiceStatus: boolean;
    VpnServiceStatus: boolean;
    HsmConnectivityStatus: boolean;
    HsmConnectivityStatus2: boolean;

    ExchangeServerAddress: string;
    ExchangeServerPort: number;

    //ecdsaA?: string;
    //ecdsaB?: string;
  
    constructor(
        IpAddress?: string,
        CpuUsage?: string,
        RamUsage?: string,
    
        DbServiceStatus?: boolean,
        VpnServiceStatus?: boolean,
        HsmConnectivityStatus?: boolean,
        HsmConnectivityStatus2?: boolean,

    
        ExchangeServerAddress?: string,
        ExchangeServerPort?: number,


      //ecdsaA?: string,
      //ecdsaB?: string,
    ) {
        this.IpAddress= "";
        this.CpuUsage= "";
        this.RamUsage= "";
    
        this.DbServiceStatus= false;
        this.VpnServiceStatus= false;
        this.HsmConnectivityStatus= false;
        this.HsmConnectivityStatus2= false;
    
        this.ExchangeServerAddress= "";
        this.ExchangeServerPort= 0;



        if(IpAddress!==undefined){
          this.IpAddress= IpAddress;
        }  
        if(CpuUsage!==undefined){
          this.CpuUsage= CpuUsage;
        }
        if(RamUsage!==undefined){
            this.RamUsage= RamUsage;
        }
      
        if(DbServiceStatus!==undefined){
              this.DbServiceStatus= DbServiceStatus;
        }
        if(VpnServiceStatus!==undefined){
          this.VpnServiceStatus= VpnServiceStatus;
        }
        if(HsmConnectivityStatus!==undefined){
          this.HsmConnectivityStatus= HsmConnectivityStatus;
        }
        if(HsmConnectivityStatus2!==undefined){
          this.HsmConnectivityStatus2= HsmConnectivityStatus2;
        }
        if(ExchangeServerAddress!==undefined){
          this.ExchangeServerAddress= ExchangeServerAddress;
        }
        if(ExchangeServerPort!==undefined){
          this.ExchangeServerPort= ExchangeServerPort;
        }


  
      //this.ecdsaA = ecdsaA || "";
      //this.ecdsaB = ecdsaB || "";
    }
    
    empty(){
      this.IpAddress= "";
      this.CpuUsage= "";
      this.RamUsage= "";
  
      this.DbServiceStatus= false;
      this.VpnServiceStatus= false;
      this.HsmConnectivityStatus= false;
      this.HsmConnectivityStatus2= false;
  
      this.ExchangeServerAddress= "";
      this.ExchangeServerPort= 0;
 

    }
  }
  